import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth';
import { Router } from '@angular/router';
import { User } from '../../classes/user';
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  user: User;

  constructor(private authService: AuthService,
              private router: Router) {
      this.user = this.authService.getUser();
  }

  ngOnInit(): void {
    this.authService.userSignedIn
        .subscribe({
              next: () => {
                this.user = this.authService.getUser();
              },
              error: (err: HttpErrorResponse) => {
                console.log(err);
              }
            }
        );
  }

  signOut(e: any) {
    e.preventDefault();
    this.authService.signOut();
    this.router.navigate(['/login']);
  }
}
